import PropTypes from 'prop-types';

import Alert from './Alert';
import AlertAnimated from './AlertAnimated';
import NotificationBase from './NotificationBase';
import Toast from './Toast';
import Toaster from './Toaster';
import useToast from './useToast';

export { Alert, AlertAnimated, Toast, Toaster, useToast };

export const Announcement = ({ children, ...props }) => (
  <NotificationBase variant="announcement" {...props}>
    {children}
  </NotificationBase>
);

Announcement.propTypes = {
  children: PropTypes.node.isRequired,
};
